import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../services/help.service';
import { HelpAction } from './actions/help.action';

export class HelpStateModel {
  redirectUri: string;
}

@State<HelpStateModel>({
  name: 'help',
  defaults: new HelpStateModel(),
})
@Injectable()
export class HelpState {
  constructor(private config: ConfigService) {}

  @Action(HelpAction.Init)
  onInitHelp(ctx: StateContext<HelpStateModel>) {
    return this.config.getConfig().pipe(
      tap((config) => {
        ctx.patchState({
          redirectUri: config.urls.redirectUri,
        });
      })
    );
  }
}
